// extracted by mini-css-extract-plugin
export var hidden = "_p1-1";
export var visible = "_p1-0";